import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';

class MatchingCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: this.props.step,
    };
  }
  render() {
    const { step, themeTileData, innerStyle } = this.props;
    const themeTiles = [];
    themeTileData.forEach((tile, idx) => {
      themeTiles.push(
        (
          <div className="theme" key={idx}>
            <Link to={`${tile.link}`}><div className={['carousel-item', tile.imgName].join(' ')} /></Link>
          </div>
        )
      );
    });
    return (
      <div className="text-center">
        <div className={['carousel-container step-', step].join('')}>
          <div className="inner" style={innerStyle}>
            {themeTiles}
          </div>
        </div>
      </div>
    );
  }
}

MatchingCardContainer.propTypes = {
  step: PropTypes.number,
  themeTileData: PropTypes.arrayOf(
    PropTypes.shape({})
  ),
  innerStyle: PropTypes.shape({}),
};

export default connect(null, null)(MatchingCardContainer);



// WEBPACK FOOTER //
// ./src/components/common/MatchingCardCarousel/MatchingCardContainer.jsx